export default __webpack_public_path__ + "static/media/home_logo.0edfb8b6.png";